import type { FC } from 'react';
import { Flex, InputNumber, Slider } from 'antd';
import styles from './preset-form.module.scss';

interface SliderNumberFieldProps {
  value: number;
  min: number;
  max: number;
  disabled?: boolean;
  addonAfter?: string;
  onChange: (value: number) => void;
}

export const SliderNumberField: FC<SliderNumberFieldProps> = ({
  value,
  min,
  max,
  disabled,
  addonAfter,
  onChange,
}) => (
  <Flex gap={12} align="center" className={styles.sliderField}>
    <Slider value={value} min={min} max={max} disabled={disabled} onChange={onChange} />
    <InputNumber
      value={value}
      min={min}
      max={max}
      disabled={disabled}
      placeholder={String(min)}
      addonAfter={addonAfter}
      onChange={(nextValue) => onChange(nextValue ?? min)}
    />
  </Flex>
);
